var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15625 11.5C6.77344 11.5 6.5 11.2266 6.5 10.8438C6.5 10.4883 6.77344 10.1875 7.15625 10.1875H12.8438C13.1992 10.1875 13.5 10.4883 13.5 10.8438C13.5 11.2266 13.1992 11.5 12.8438 11.5H7.15625ZM7.15625 14.125C6.77344 14.125 6.5 13.8516 6.5 13.4688C6.5 13.1133 6.77344 12.8125 7.15625 12.8125H10.2188C10.5742 12.8125 10.875 13.1133 10.875 13.4688C10.875 13.8516 10.5742 14.125 10.2188 14.125H7.15625ZM7.15625 8.875C6.77344 8.875 6.5 8.60156 6.5 8.21875C6.5 7.86328 6.77344 7.5625 7.15625 7.5625H12.8438C13.1992 7.5625 13.5 7.86328 13.5 8.21875C13.5 8.60156 13.1992 8.875 12.8438 8.875H7.15625ZM14.375 2.75C15.332 2.75 16.125 3.54297 16.125 4.5V15C16.125 15.9844 15.332 16.75 14.375 16.75H5.625C4.64062 16.75 3.875 15.9844 3.875 15V4.5C3.875 3.54297 4.64062 2.75 5.625 2.75H14.375ZM14.8125 15V6.25H5.1875V15C5.1875 15.2461 5.37891 15.4375 5.625 15.4375H14.375C14.5938 15.4375 14.8125 15.2461 14.8125 15Z",
    fill: "#1D2132",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.fe1123ffd2e75263e5db94bc1570db91.svg";
export { ForwardRef as ReactComponent };